import React, { Fragment, useEffect, useState } from 'react';
import { Spinner, Table, Row, Col, Container, Button } from "reactstrap";
import useSolution from '../../hooks/useSolution';
import { Link, useNavigate } from 'react-router-dom';
import SolutionDetails from './Details';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { DateConstants } from '../../constants/date';
import { SolutionConstants } from '../../constants/solution';
import ContractorProfile from '../Project/assets/contractor-profile.jpg';
import ArrowRightBlue from '../Project/assets/arrow-right-blue.svg';
import MapPin from '../Project/assets/map-pin.svg';
import CalendarBlank from '../Project/assets/calendar-blank.svg';
import Email from '../Project/assets/email.svg';
import HardHat from '../Project/assets/hard-hat.svg';
import CellPhone from '../Project/assets/cell-phone.svg'
import { InteractionStatus } from '@azure/msal-browser';
import sort, { SORT_DIR } from '../Utilities/Sort';
import get from 'lodash/get';
import './solution.scss'

function SolutionList() {
    const [solutionListKey, setSolutionListKey] = useState(Date.now());
    const solutions = useSolution();
    const navigate = useNavigate();
    const isAuthenticated = useIsAuthenticated();
    const { inProgress } = useMsal();

    useEffect(() => {
		if (inProgress === InteractionStatus.None) {
			if (!isAuthenticated) {
				navigate('/auth/login', {state: {callbackUrl: window.location.pathname}});
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, inProgress]);

    useEffect(() => {
        solutions.getList();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionListKey]);

    const SolutionsLoading = () => {
        return (
            <Fragment>
                <tr>
                    <td className="text-center" colSpan="4">
                        <Spinner size="sm" />
                        <p className="m-0">Loading</p>
                    </td>
                </tr>
            </Fragment>
        )
    }

    const solutionList = solutions.solutionList 
        ? sort(solutions.solutionList, SORT_DIR.DESC, {sortBy: (item) => get(item, 'createdAt')})
        : [];

    const SolutionRows = () => {
        return (
            <Fragment>
                {
                    solutionList.map((solution) => {
                        return (
                            <tr key={solution.id}>
                                <td>{solution.location.locality}</td>
                                <td>{solution.location.addressLine}</td>
                                <td>{solution.location.postalCode}</td>
                                <td className='status-badge-container'>
                                    <span className={`badge ${solution.stateAssignment.state.code}`}>
                                        {solution.stateAssignment.state.name}
                                    </span>
                                </td>
                                <td className="text-end">USD {solution.totalBudget}</td>
                                <td>
                                    <Link to={"/solution/" + solution.id}>Details</Link>
                                </td>
                            </tr>
                        );
                    })
                }
            </Fragment>
        )
    }

    const Empty = () => {
        return (
            <Fragment>
                <tr className="text-center">
                    <td colSpan="4">
                        You don't have any projects yet! You can <a href="../../project/create">create one here</a>
                    </td>
                </tr>
            </Fragment>
        )
    }

    const solutionUpdated = (solution) => {
        setSolutionListKey(Date.now());
    }

    const handleSolutionView = (id) => {
        navigate("/solution/" + id)
    }

    const showContractorData = (state) => {
        return state === SolutionConstants.STATE.CONTRACTOR_CONFIRMED
            || state === SolutionConstants.STATE.CONTRACT_CREATED;
    }

    return isAuthenticated ? (
        <Fragment key={solutionListKey}>
            <div className='solution-list-main-container'>
                <div className='d-lg-none project-list-mobile-container mt-4'>
                    <div>
                        <Row>
                            <Col md="2">
                                <span className="project-list-title">Your Projects</span>
                            </Col>
                        </Row>
                        <Row className='project-list-status-row mt-3'>
                            <Col md="2">
                                <span className="project-list-status">In progress</span>
                            </Col>
                        </Row>
                        {
                            solutionList && solutionList.length > 0 && solutionList.map((solution) => {
                                let phone = solution.contractor?.phone;
                                return (
                                    <div key={solution.id}>
                                        <Row className={'project-list-card mt-4'}>
                                            <Col sm="12" className='h-100'>
                                                <div className='carousel-card carousel-item active'>
                                                    <Container className='h-100'>
                                                        <Row className='h-100 fs-4'>
                                                            <Col md="1" className='w-75'>
                                                                <div className='mt-3 status-badge-container'>
                                                                    <div className='text-uppercase'>
                                                                        <span className={`badge ${solution.stateAssignment.state.code}`}>
                                                                            {solution.stateAssignment.state.name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className='mt-0 h-50'>
                                                                    {
                                                                        showContractorData(solution.stateAssignment.state.code) &&
                                                                        <Row className='h-25'>
                                                                            <div className='project-details'>
                                                                                <div className='m-0 w-100 detail-row'>
                                                                                    <img className='detail-image' src={HardHat} alt="" />
                                                                                    <span className='detail-text'>
                                                                                        {`${solution.contractor?.firstName} ${solution.contractor?.lastName}`}
                                                                                    </span>
                                                                                </div>
                                                                                <div className='m-0 w-100 detail-row'>
                                                                                    <img className='detail-image' src={Email} alt="" />
                                                                                    <span className='detail-text'>
                                                                                        <a className='email' href={`mailto: ${solution.contractor?.email}`}>
                                                                                            {solution.contractor?.email}
                                                                                        </a>
                                                                                    </span>
                                                                                </div>
                                                                                    {
                                                                                        phone &&
                                                                                        <div className='m-0 w-100 detail-row'>
                                                                                            <img className='detail-image' src={CellPhone} alt="" />
                                                                                            <span className='detail-text'>
                                                                                                {`${phone}`}
                                                                                            </span>
                                                                                        </div>
                                                                                    }
                                                                            </div>
                                                                        </Row>
                                                                    }
                                                                    <Row className={`mt-${phone ? 5 : 4} h-50`}>
                                                                        <Col>
                                                                            <p className='project-name'>{solution.projects[0]?.description}</p>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='h-50'>
                                                                        <div className='project-details'>
                                                                            <div className='m-0 w-100 detail-row'>
                                                                                <img className='detail-image' src={MapPin} alt="" />
                                                                                <span className='detail-text'>
                                                                                    {`${solution.location?.postalCode}, ${solution.location?.locality}, ${solution.location?.administrativeAreaName}`}
                                                                                </span>
                                                                            </div>
                                                                            <div className='m-0 w-100 detail-row'>
                                                                                <img className='detail-image' src={CalendarBlank} alt="" />
                                                                                <span className='detail-text'>
                                                                                    {`Created on ${DateConstants.MONTHS[new Date(Date.parse(solution.createdAt)).getMonth()]} ${new Date(Date.parse(solution.createdAt)).getDate()}`}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </Row>
                                                                </div>

                                                            </Col>
                                                            <Col md="1" className='w-25'>
                                                                <Row className='h-50'>
                                                                    <Col className='gx-0 text-end contractor-profile'>
                                                                        <img className='mt-3' src={ContractorProfile} alt="Contractor" />
                                                                    </Col>
                                                                </Row>
                                                                <Row className='h-50'>
                                                                    <Col className='gx-0 right-arrow'>
                                                                        <div className='h-100 d-flex align-items-end'>
                                                                            <div className='w-100 text-end'>
                                                                                <Button onClick={() => handleSolutionView(solution.id)} color='link p-0 mb-3'>
                                                                                    <img src={ArrowRightBlue} alt='' />
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Container>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="solution-list-container d-none d-lg-block">
                    <div className="row header my-4">
                        <h1 className="fs-4">My Projects</h1>
                    </div>
                    <div className="row solution-table form-group">
                        <Table hover>
                            <thead>
                                <tr>
                                    <th>City</th>
                                    <th>Address</th>
                                    <th>Postcode</th>
                                    <th>Status</th>
                                    <th className="text-end">Total Budget</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    solutions.loading || (solutions.solutionList == null && !solutions.error)
                                        ? <SolutionsLoading />
                                        : solutions.solutionList && solutions.solutionList.length > 0
                                            ? <SolutionRows />
                                            : <Empty />
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
            <div className='solution-details-container'>
                <SolutionDetails solutions={solutions && solutions.solutionList ? solutions.solutionList : []}
                    onSolutionUpdated={(solution) => { solutionUpdated(solution) }} />
            </div>
        </Fragment>
    ) : '';
}

export default SolutionList;